// const Colors = [
//   '#F8F18A',
//   '#E77E68',
//   '#4CBADD',
//   '#54AC81',
//   '#DE5B74',
//   '#5F6A97',
// ];

// export default Colors;

import { lab } from 'd3-color';

export const ColorPalette = [
  '#5d6297',
  '#d0546c',
  '#dc5112',
  '#ed9f22',
  '#3f9750',
];

export const RingColorPalette = ColorPalette.map((color) => {
  const changedColor = lab(color);
  changedColor.l -= 10;
  if (changedColor.l < 0) {
    changedColor.l = 0;
  }
  return changedColor;
});

const Colors = {
  almostWhite: 'rgba(255, 255, 255, 0.9)',
  background: '#eee',
  badgeBackground: '#ff4b77',
  highlight: '#ff4b77',
  error: '#ee6e5a',
  errorBackground: '#fff1ef',
  mutedText: '#888',
  text: '#222',
  primary: '#49AA78',
  secondary: '#37b5ea',
  notAvailable: 'gray',
  infoBackground: '#d1ecf1',
  infoColor: '#0c5460',
};

export default Colors;



// WEBPACK FOOTER //
// ./src/lib/Colors.ts